export const disabledTooltip = (key: string) => {
    const element = document.getElementById(key);
    if (!element) return true;
    return element.scrollWidth === element.clientWidth;
};
